import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';

@Component({
  selector: 'app-loads-pay-popup',
  templateUrl: './loads-pay-popup.component.html',
  styleUrls: ['./loads-pay-popup.component.scss']
})
export class LoadsPayPopupComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LoadsPayPopupComponent | any>,
    private router: Router,
  ) { }

  role: string;
  loadNumber: number;
  driverpayInvoiceStatus: string = "pending";
  loadComponent: boolean = true;
  pickupInfo: any;
  ngOnInit(): void {
    console.log(this.data?.load?.pickupinfo[0]?.driver1, this.data?.load?.pickupinfo[0]?.driver2);
    console.log(this.data?.load?.pickupinfo[0]?.carrier);
    if(this.data?.load?.pickupinfo[0]?.driver1 || this.data?.load?.pickupinfo[0]?.driver2) {
      this.role = "driver";
    }
    else if(this.data?.load?.pickupinfo[0]?.carrier) {
      this.role = "carrier";
    }
    else {
      this.role = "driver";
    }
    this.pickupInfo = this.data?.load?.pickupinfo[0];
    this.loadNumber = this.data?.load?.loadNumber;
    this.driverpayInvoiceStatus = this.data?.load?.driverpayInvoiceStatus;
  }

  onSelectedRole(event) {
    switch (event.target.value) {
      case 'driver':
        // this.router.navigateByUrl("/loadpay/driver-payment");
        this.role = "driver";
        break;
      case 'carrier':
        // this.router.navigateByUrl("/loadpay/carrier-payment");
        this.role = "carrier";
        break;
      case 'dispatcher':
        // this.router.navigateByUrl("/loadpay/dispatcher-payment");
        this.role = "dispatcher";
        break;

      default:
        break;
    }
    // Reset the component by toggling the `loadComponent` flag
    this.loadComponent = false;
    setTimeout(() => {
      this.loadComponent = true;
    }, 0); // Allows Angular to detect the change
  }

  close() {
    this.dialogRef.close()
  }
  nextStep(stepper: MatStepper) {
    console.log(stepper.selectedIndex);
    if (stepper.selectedIndex === 2) {
      this.dialogRef.close();
    } else {
      stepper.next();
    }
  }
  getStepData(stepper: MatStepper) {
    // return stepper.selectedIndex;
  }
}
